define(["react","underscore","prop-types","@bingads-webui-react/i18n-context","@bingads-webui/build-legacy-i18n","@bingads-webui/viewmodel-schema","@bingads-webui-react/error-mapper"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__590__, __WEBPACK_EXTERNAL_MODULE__1198__, __WEBPACK_EXTERNAL_MODULE__1213__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1188);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 1188:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1189);


/***/ }),

/***/ 1189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  withValidation: true,
  ValidationGroup: true,
  withError: true,
  ErrorMessages: true,
  DefaultAdapter: true,
  CheckedAdapter: true,
  CheckedItemAdapter: true,
  AdapterFactory: true,
  GenericAdapter: true,
  withCustomValidation: true,
  withServerError: true,
  useServerError: true,
  ServerErrorContext: true,
  ServerErrorGroup: true,
  ServerErrorEntity: true,
  ServerErrorEntityContext: true
};
Object.defineProperty(exports, "withValidation", {
  enumerable: true,
  get: function get() {
    return _withValidation.withValidation;
  }
});
Object.defineProperty(exports, "ValidationGroup", {
  enumerable: true,
  get: function get() {
    return _validationGroup.ValidationGroup;
  }
});
Object.defineProperty(exports, "withError", {
  enumerable: true,
  get: function get() {
    return _withError.withError;
  }
});
Object.defineProperty(exports, "ErrorMessages", {
  enumerable: true,
  get: function get() {
    return _errorMessages.ErrorMessages;
  }
});
Object.defineProperty(exports, "DefaultAdapter", {
  enumerable: true,
  get: function get() {
    return _defaultAdapter.DefaultAdapter;
  }
});
Object.defineProperty(exports, "CheckedAdapter", {
  enumerable: true,
  get: function get() {
    return _checkedAdapter.CheckedAdapter;
  }
});
Object.defineProperty(exports, "CheckedItemAdapter", {
  enumerable: true,
  get: function get() {
    return _checkedItemAdapter.CheckedItemAdapter;
  }
});
Object.defineProperty(exports, "AdapterFactory", {
  enumerable: true,
  get: function get() {
    return _adapterFactory.AdapterFactory;
  }
});
Object.defineProperty(exports, "GenericAdapter", {
  enumerable: true,
  get: function get() {
    return _genericAdapter.GenericAdapter;
  }
});
Object.defineProperty(exports, "withCustomValidation", {
  enumerable: true,
  get: function get() {
    return _withCustomValidation.withCustomValidation;
  }
});
Object.defineProperty(exports, "withServerError", {
  enumerable: true,
  get: function get() {
    return _withServerError.withServerError;
  }
});
Object.defineProperty(exports, "useServerError", {
  enumerable: true,
  get: function get() {
    return _withServerError.useServerError;
  }
});
Object.defineProperty(exports, "ServerErrorContext", {
  enumerable: true,
  get: function get() {
    return _serverErrorContext.ServerErrorContext;
  }
});
Object.defineProperty(exports, "ServerErrorGroup", {
  enumerable: true,
  get: function get() {
    return _serverErrorContext.ServerErrorGroup;
  }
});
Object.defineProperty(exports, "ServerErrorEntity", {
  enumerable: true,
  get: function get() {
    return _serverErrorContext.ServerErrorEntity;
  }
});
Object.defineProperty(exports, "ServerErrorEntityContext", {
  enumerable: true,
  get: function get() {
    return _serverErrorContext.ServerErrorEntityContext;
  }
});

var _withValidation = __webpack_require__(1190);

var _validationGroup = __webpack_require__(1203);

var _withError = __webpack_require__(1204);

var _errorMessages = __webpack_require__(1205);

var _defaultAdapter = __webpack_require__(1191);

var _checkedAdapter = __webpack_require__(1206);

var _checkedItemAdapter = __webpack_require__(1207);

var _adapterFactory = __webpack_require__(1192);

var _genericAdapter = __webpack_require__(1208);

var _withCustomValidation = __webpack_require__(1209);

var _withServerError = __webpack_require__(1211);

var _serverErrorContext = __webpack_require__(1212);

var _serverErrorUtils = __webpack_require__(1214);

Object.keys(_serverErrorUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _serverErrorUtils[key];
    }
  });
});

/***/ }),

/***/ 1190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withValidationInternal = withValidationInternal;
exports.withValidation = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _defaultAdapter = __webpack_require__(1191);

var _validationContext = __webpack_require__(1193);

var _validationItem = __webpack_require__(1194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function withValidationInternal(Component, PrimitiveComponent = null, Adapter = _defaultAdapter.DefaultAdapter) {
  const ContextConsumer = props => {
    const renderValidationItem = contextProps => {
      const onValidate = accessor => {
        if (_underscore.default.isFunction(props.validationProps.onValidate)) {
          props.validationProps.onValidate(accessor);
        }

        _underscore.default.result(contextProps, 'notifyDataChange');
      };

      const validationProps = _underscore.default.defaults({
        onValidate
      }, PrimitiveComponent === null ? {} : {
        primitiveAdapter: new Adapter(PrimitiveComponent)
      }, props.validationProps, contextProps);

      return _react.default.createElement(Component, _extends({}, props, {
        validationProps: validationProps
      }));
    };

    return _react.default.createElement(_validationContext.ValidationContext.Consumer, null, renderValidationItem);
  };

  ContextConsumer.propTypes = {
    validationProps: _propTypes.default.shape({
      onValidate: _propTypes.default.func
    })
  };
  ContextConsumer.defaultProps = {
    validationProps: {
      onValidate: _underscore.default.noop
    }
  };
  return ContextConsumer;
}

const withValidation = _underscore.default.partial(withValidationInternal, _validationItem.ValidationItem);

exports.withValidation = withValidation;

/***/ }),

/***/ 1191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultAdapter = void 0;

var _adapterFactory = __webpack_require__(1192);

const DefaultAdapter = (0, _adapterFactory.AdapterFactory)({
  convertEventToValue: event => event.target.value
});
exports.DefaultAdapter = DefaultAdapter;

/***/ }),

/***/ 1192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdapterFactory = AdapterFactory;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AdapterFactory({
  convertEventToValue = _underscore.default.identity,
  defaultValue = '',
  valueToInject = 'value',
  functionToInject = 'onChange'
}) {
  var _temp;

  return _temp = class DefaultAdapter {
    constructor(PrimitiveComponent) {
      _defineProperty(this, "onChange", (eventObject, ...args) => {
        const value = convertEventToValue(eventObject, args);
        this.onChangeParam(value);

        if (_underscore.default.isFunction(this.props.onChange)) {
          this.props.onChange(eventObject, args);
        }
      });

      this.component = PrimitiveComponent;
    }

    getValue(props) {
      return props[valueToInject];
    }

    renderComponent(props, value, onChange) {
      const PrimitiveComponent = this.component;
      this.onChangeParam = onChange;
      this.props = props;
      const injectedProps = {
        [valueToInject]: value || defaultValue,
        [functionToInject]: this.onChange
      }; // When the value is not set, we set it to '',
      // as we always want the input to be controlled

      return _react.default.createElement(PrimitiveComponent, _extends({}, props, injectedProps));
    }

  }, _temp;
}

/***/ }),

/***/ 1193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationContext = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ValidationContext = _react.default.createContext({
  notifyDataChange: _underscore.default.noop
});

exports.ValidationContext = ValidationContext;

/***/ }),

/***/ 1194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationItem = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _itemNode = __webpack_require__(1195);

var _groupNode = __webpack_require__(1200);

var _viewmodelUtil = __webpack_require__(1199);

var _fieldCreator = __webpack_require__(1197);

var _withDefaultI18n = __webpack_require__(1201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const getFieldValue = (convertor, field, data) => {
  const fieldData = (0, _viewmodelUtil.unpack)(data, field);
  return _underscore.default.isUndefined(fieldData) ? fieldData : convertor.fromModel(fieldData);
}; // get the string value processed by i18n, may be differnt from original string (e.g. rounding)


const getProcessedValue = (value, convertor) => convertor.fromModel(convertor.toModel(value));

const getNewState = (props, state = {}) => {
  const _props$validationProp = props.validationProps,
        schema = _props$validationProp.schema,
        i18n = _props$validationProp.i18n,
        field = _props$validationProp.field,
        data = _props$validationProp.data,
        primitiveAdapter = _props$validationProp.primitiveAdapter,
        _props$validationProp2 = _props$validationProp.convertor,
        convertor = _props$validationProp2 === void 0 ? {} : _props$validationProp2;

  const fieldConvertor = _underscore.default.defaults(convertor, (0, _fieldCreator.createSchemaField)(schema, i18n, field).conversion);

  const fieldValue = getFieldValue(fieldConvertor, field, data);

  if (!_underscore.default.isUndefined(fieldValue) && fieldValue !== state.source) {
    // field prop change detected, update state
    return {
      value: getProcessedValue(state.value, fieldConvertor) === fieldValue ? state.value : fieldValue,
      source: fieldValue
    };
  }

  const propValue = primitiveAdapter.getValue(props);
  const processed = _underscore.default.isUndefined(propValue) ? propValue : getProcessedValue(propValue, fieldConvertor);

  if (!_underscore.default.isUndefined(propValue) && processed !== state.source) {
    // value prop change detected, update state
    return {
      value: propValue,
      source: processed
    };
  }

  return null;
};

class ValidationItemInternal extends _react.default.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    return getNewState(nextProps, prevState);
  }

  constructor(props) {
    super(props);

    _defineProperty(this, "setText", text => {
      this.setState({
        value: text
      });
      this.itemNode.setDirty();
    });

    this.itemNode = new _itemNode.ItemNode(props.validationProps);
    this.state = getNewState(props) || {
      value: this.itemNode.default
    };
  }

  componentDidMount() {
    this.itemNode.register();
    this.triggerValidate();
  }

  componentDidUpdate(prevProps, prevState) {
    const didSkipValidationChanged = this.props.validationProps.skipValidation !== prevProps.validationProps.skipValidation;

    if (!_underscore.default.isEqual(prevState.value, this.state.value) || didSkipValidationChanged) {
      if (didSkipValidationChanged) {
        this.itemNode.setSkipValidation(this.props.validationProps.skipValidation);
      }

      this.triggerValidate();
    }
  }

  componentWillUnmount() {
    this.itemNode.unregister();

    _underscore.default.result(this.props.validationProps, 'notifyDataChange');
  }

  getClassName() {
    const _this$props = this.props,
          className = _this$props.className,
          validationProps = _this$props.validationProps;

    const _$defaults = _underscore.default.defaults(validationProps, {
      errorClassName: 'error'
    }),
          errorClassName = _$defaults.errorClassName,
          forceErrorClassName = _$defaults.forceErrorClassName;

    const isItemNodeInvalid = !this.itemNode.isValid && this.itemNode.isDirty;

    if (!_underscore.default.isEmpty(errorClassName) && (isItemNodeInvalid || forceErrorClassName)) {
      return _underscore.default.isEmpty(className) ? errorClassName : `${className} ${errorClassName}`;
    }

    return className;
  }

  triggerValidate() {
    if (_underscore.default.isFunction(this.props.validationProps.onValidate)) {
      this.props.validationProps.onValidate(this.itemNode.accessor);
    }
  }

  render() {
    const primitiveAdapter = this.props.validationProps.primitiveAdapter;

    const componentProps = _underscore.default.omit(this.props, 'validationProps');

    this.itemNode.value = this.state.value;

    _underscore.default.extend(componentProps, {
      className: this.getClassName()
    });

    return primitiveAdapter.renderComponent(componentProps, this.state.value, this.setText);
  }

}

_defineProperty(ValidationItemInternal, "propTypes", {
  validationProps: _propTypes.default.shape({
    onValidate: _propTypes.default.func,
    i18n: _withDefaultI18n.i18nPropType.isRequired,
    parent: _propTypes.default.instanceOf(_groupNode.GroupNode),
    schema: _propTypes.default.shape({
      type: _propTypes.default.string
    }),
    field: _propTypes.default.string,
    validator: _propTypes.default.func,
    convertor: _propTypes.default.shape({
      fromJSON: _propTypes.default.func,
      toJSON: _propTypes.default.func
    }),
    errorProcessor: _propTypes.default.func,
    primitiveAdapter: _propTypes.default.shape({
      getValue: _propTypes.default.func,
      renderComponent: _propTypes.default.func
    }).isRequired,
    errorClassName: _propTypes.default.string,
    data: _propTypes.default.object,
    // eslint-disable-line
    skipValidation: _propTypes.default.bool
  }),
  className: _propTypes.default.string
});

_defineProperty(ValidationItemInternal, "defaultProps", {
  validationProps: {
    onValidate: _underscore.default.noop,
    parent: undefined,
    schema: undefined,
    field: undefined,
    validator: undefined,
    convertor: undefined,
    errorProcessor: undefined,
    skipValidation: false
  },
  className: undefined
});

const ValidationItem = (0, _withDefaultI18n.withDefaultI18n)(ValidationItemInternal);
exports.ValidationItem = ValidationItem;

/***/ }),

/***/ 1195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemNode = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _baseNode = __webpack_require__(1196);

var _fieldCreator = __webpack_require__(1197);

var _viewmodelUtil = __webpack_require__(1199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getConvertor = (custom, node) => _underscore.default.defaults(custom, node.vmField.conversion);

const createDefaultFields = ({
  convertor = {},
  validator
}) => {
  const defaultValidator = (value, node) => {
    const converted = getConvertor(convertor, node).toModel(value);
    return node.vmField.validation.validate(converted);
  };

  const defaultConvertor = {
    fromJSON: (json, node) => {
      const jsonField = (0, _viewmodelUtil.unpack)(json, node.field);

      _underscore.default.extend(node, {
        value: getConvertor(convertor, node).fromModel(jsonField)
      });
    },
    toJSON: node => {
      const jsonField = getConvertor(convertor, node).toModel(node.value);
      return (0, _viewmodelUtil.pack)(jsonField, node.field);
    }
  };
  return {
    customValidator: _underscore.default.isFunction(validator) ? validator : null,
    validator: defaultValidator,
    convertor: defaultConvertor
  };
};

const defaultErrorProcessor = errors => _underscore.default.first(_underscore.default.values(errors), 1);

class ItemNode extends _baseNode.BaseNode {
  constructor(params) {
    super(_underscore.default.defaults(createDefaultFields(params), params));
    this.vmField = (0, _fieldCreator.createSchemaField)(this.schema, params.i18n, this.field);
    this.errorProcessor = params.errorProcessor || defaultErrorProcessor;
    this.rawValue = {};
  }

  validate(changed) {
    super.validate(changed);

    if (!_underscore.default.isArray(this.messages)) {
      this.messages = this.errorProcessor(this.messages, changed, this.field, this.schema);
    }
  }

  setSkipValidation(skipValidation) {
    super.setSkipValidation(skipValidation);
    this.validate(this.rawValue);
  }

  set value(newValue) {
    if (newValue !== this.rawValue) {
      this.rawValue = newValue;
      this.validate(newValue);
      this.parent.notifyChildChange(this);
    }
  }

  get value() {
    return this.rawValue;
  }

  get default() {
    this.fromJSON((0, _viewmodelUtil.pack)(this.vmField.default, this.field));
    return this.value;
  }

}

exports.ItemNode = ItemNode;

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseNode = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAccessor(node) {
  return {
    get data() {
      return node.toJSON();
    },

    get messages() {
      return node.messages;
    },

    get isValid() {
      return node.isValid;
    },

    get isDirty() {
      return node.isDirty;
    }

  };
}

class BaseNode {
  constructor({
    parent,
    schema,
    field,
    validator,
    customValidator,
    convertor,
    skipValidation = false
  }) {
    this.parent = parent || {
      notifyChildChange: _underscore.default.noop,
      registerChild: _underscore.default.noop,
      unregisterChild: _underscore.default.noop,
      setDirty: _underscore.default.noop
    };
    this.schema = schema;
    this.field = field;
    this.messages = [];
    this.validator = validator;
    this.customValidator = customValidator;
    this.convertor = convertor;
    this.isDirty = false;
    this.skipValidation = skipValidation;
  }

  register() {
    this.parent.registerChild(this);
  }

  unregister() {
    this.parent.unregisterChild(this);
  }

  validate(changed) {
    this.messages = this.skipValidation ? {} : this.getValidationErrorMessages(changed);
  }

  getValidationErrorMessages(changed) {
    if (_underscore.default.isFunction(this.customValidator)) {
      return this.customValidator(changed, _underscore.default.partial(this.validator, _underscore.default, this));
    }

    return this.validator(changed, this);
  }

  get isValid() {
    return _underscore.default.isEmpty(this.messages);
  }

  fromJSON(json) {
    this.convertor.fromJSON(json, this);
  }

  toJSON() {
    return this.convertor.toJSON(this);
  }

  setDirty() {
    this.isDirty = true;
    this.parent.setDirty();
  }

  setSkipValidation(skipValidation) {
    this.skipValidation = skipValidation;
  }

  get accessor() {
    return createAccessor(this);
  }

}

exports.BaseNode = BaseNode;

/***/ }),

/***/ 1197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSchemaField = createSchemaField;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _viewmodelSchema = __webpack_require__(1198);

var _viewmodelUtil = __webpack_require__(1199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const emptyField = {
  default: null,
  conversion: {
    fromModel: value => value,
    toModel: value => value
  },
  validation: {
    validate: () => []
  }
};

function createSchemaField(schema, i18n, field) {
  if (_underscore.default.isEmpty(schema) || _underscore.default.isEmpty(field)) {
    return emptyField;
  }

  const vmSchema = new _viewmodelSchema.ViewmodelSchema(schema, i18n, [field]);
  const vmField = (0, _viewmodelUtil.unpack)(vmSchema, field);
  return {
    default: vmField.default,
    conversion: vmField.conversion,
    validation: {
      validate: value => _underscore.default.reduce(vmField.validation, (errors, validator, name) => {
        if (!validator.isValid(value)) {
          _underscore.default.extend(errors, {
            [name]: validator.message
          });
        }

        return errors;
      }, {})
    }
  };
}

/***/ }),

/***/ 1198:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1198__;

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unpack = unpack;
exports.pack = pack;
exports.merge = merge;

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unpack(model, path = '') {
  return _underscore.default.reduce(path.split('/'), (obj, seg) => _underscore.default.result(obj, seg), model);
}

function pack(field, path = '') {
  return _underscore.default.reduceRight(path.split('/'), (obj, seg) => ({
    [seg]: obj
  }), field);
}

function merge(target, source) {
  _underscore.default.each(_underscore.default.keys(source), key => {
    if (_underscore.default.has(target, key)) {
      merge(target[key], source[key]);
    } else {
      _underscore.default.extend(target, {
        [key]: source[key]
      });
    }
  });
}

/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupNode = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _baseNode = __webpack_require__(1196);

var _viewmodelUtil = __webpack_require__(1199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const defaultValidator = (changed, node) => _underscore.default.reduce(node.items, (messages, item) => messages.concat(item.messages), []);

const defaultConvertor = {
  fromJSON: (json, node) => {
    _underscore.default.each(node.items, item => {
      item.fromJSON(json);
    });
  },
  toJSON: node => _underscore.default.reduce(node.items, (result, item) => {
    (0, _viewmodelUtil.merge)(result, item.toJSON());
    return result;
  }, {})
};

class GroupNode extends _baseNode.BaseNode {
  constructor(params) {
    super(_underscore.default.defaults(params, {
      validator: defaultValidator,
      convertor: defaultConvertor
    }));
    this.items = [];
  }

  notifyChildChange(field) {
    this.validate(field);
    this.parent.notifyChildChange(this);
  }

  registerChild(newItem) {
    this.items.push(newItem);
    this.notifyChildChange(newItem);
  }

  unregisterChild(item) {
    this.items = _underscore.default.without(this.items, item);
    this.notifyChildChange(item);
  }

}

exports.GroupNode = GroupNode;

/***/ }),

/***/ 1201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDefaultI18n = withDefaultI18n;
exports.i18nPropType = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _i18nContext = __webpack_require__(16);

var _buildLegacyI18n = __webpack_require__(590);

var _validationStringMap = __webpack_require__(1202);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const i18nPropType = _propTypes.default.shape({
  getString: _propTypes.default.func,
  isValidDecimal: _propTypes.default.func,
  parseDecimal: _propTypes.default.func,
  formatDecimal: _propTypes.default.func
});

exports.i18nPropType = i18nPropType;

const getValidationProps = (validationProps, i18n) => {
  if (_underscore.default.isEmpty(i18n)) {
    return validationProps;
  }

  const legacyi18n = (0, _buildLegacyI18n.buildLegacyI18n)(i18n, [_validationStringMap.ValidationStringMap]);
  return _underscore.default.extend(validationProps, {
    i18n: legacyi18n
  });
};

function withDefaultI18n(Component) {
  const WrappedComponent = (_ref) => {
    let validationProps = _ref.validationProps,
        props = _objectWithoutProperties(_ref, ["validationProps"]);

    if (_underscore.default.isEmpty(_underscore.default.result(validationProps, 'i18n'))) {
      return _react.default.createElement(_i18nContext.I18nContext.Consumer, null, i18n => _react.default.createElement(Component, _extends({
        validationProps: getValidationProps(validationProps, i18n)
      }, props)));
    }

    return _react.default.createElement(Component, _extends({
      validationProps: validationProps
    }, props));
  };

  WrappedComponent.propTypes = {
    validationProps: _propTypes.default.shape({})
  };
  WrappedComponent.defaultProps = {
    validationProps: undefined
  };
  return _react.default.memo(WrappedComponent);
}

/***/ }),

/***/ 1202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationStringMap = void 0;
// TODO[new-i18n-issue]: a workaround to use build-in validation string map
// as when serveral features import the same ValidationStringMap
// currently the webpack shared bundle strategy will cause the validation string not generated
const ValidationStringMap = {
  Validation_Base_Field_Not_Valid: _TL_('Field is not valid'),
  Validation_NotEmpty_Required_Field: _TL_('Required field'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  Validation_String_Min_Length: _TL_('Field should exceed {{minlength}} characters'),
  Validation_String_Invalid_Characters: _TL_('Field contains invalid characters'),
  Validation_Number_Require_Numeric: _TL_('Field requires numeric value'),
  Validation_Number_Max_Length: _TL_('Number should not exceed max length'),
  Validation_Number_Range_Min: _TL_('Number should be larger than {{min}}'),
  Validation_Number_Range_Max: _TL_('Number should be smaller than {{max}}'),
  Validation_Number_Range_Between: _TL_('Number should be between {{min}} and {{max}}'),
  Validation_Array_Size_Max: _TL_('List should have at most {{max}} items'),
  Validation_Array_Size_Between: _TL_('List should have at least {{min}} and at most {{max}} items'),
  Validation_Array_Items_Invalid: _TL_('Some of items in list are invalid'),
  Validation_Array_Items_Duplicate: _TL_('List has duplicate items'),
  Validation_NegativeKeywords_ListName_Required: _TL_('The list name is required.'),
  Validation_NegativeKeywords_Max_Count: _TL_('Maximum of 5,000 negative keywords'),
  Validation_NegativeKeywords_Invalid_Keywords: _TL_('Some of the keyword(s) are invalid: {{invalidKeywords}}'),
  Validation_NegativeKeywords_Required: _TL_('At least 1 negative keyword is required.')
};
exports.ValidationStringMap = ValidationStringMap;

/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationGroup = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _groupNode = __webpack_require__(1200);

var _validationContext = __webpack_require__(1193);

var _withDefaultI18n = __webpack_require__(1201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ValidationGroupInternal extends _react.default.Component {
  constructor(props) {
    super(props);
    const _props$validationProp = props.validationProps,
          schema = _props$validationProp.schema,
          parent = _props$validationProp.parent,
          validator = _props$validationProp.validator,
          convertor = _props$validationProp.convertor,
          stopPropagation = _props$validationProp.stopPropagation;
    this.groupNode = new _groupNode.GroupNode({
      schema,
      parent: stopPropagation ? undefined : parent,
      validator,
      convertor
    });
    this.parent = parent;
  }

  componentDidMount() {
    this.groupNode.register();
    this.triggerValidate();
  }

  componentWillUnmount() {
    this.groupNode.unregister();

    _underscore.default.result(this.props.validationProps, 'notifyDataChange');
  }

  getGroupOptions(options) {
    const _this$props$validatio = this.props.validationProps,
          _this$props$validatio2 = _this$props$validatio.schema,
          schema = _this$props$validatio2 === void 0 ? options.schema : _this$props$validatio2,
          _this$props$validatio3 = _this$props$validatio.data,
          data = _this$props$validatio3 === void 0 ? options.data : _this$props$validatio3,
          _this$props$validatio4 = _this$props$validatio.parent,
          parent = _this$props$validatio4 === void 0 ? options.parent : _this$props$validatio4,
          _this$props$validatio5 = _this$props$validatio.i18n,
          i18n = _this$props$validatio5 === void 0 ? options.i18n : _this$props$validatio5,
          validator = _this$props$validatio.validator,
          convertor = _this$props$validatio.convertor,
          stopPropagation = _this$props$validatio.stopPropagation;

    if (!stopPropagation && !_underscore.default.isEqual(this.parent, parent)) {
      this.parent = parent;
      this.groupNode = new _groupNode.GroupNode({
        schema,
        parent,
        validator,
        convertor
      });
    }

    const notifyDataChange = () => {
      this.triggerValidate();

      if (!stopPropagation) {
        // Do not notify change to upper level validation context provider
        _underscore.default.result(options, 'notifyDataChange');
      }
    };

    return {
      parent: this.groupNode,
      schema,
      i18n,
      data,
      notifyDataChange
    };
  }

  triggerValidate() {
    if (_underscore.default.isFunction(this.props.validationProps.onValidate)) {
      this.props.validationProps.onValidate(this.groupNode.accessor);
    }
  }

  render() {
    return _react.default.createElement(_validationContext.ValidationContext.Consumer, null, options => _react.default.createElement(_validationContext.ValidationContext.Provider, {
      value: this.getGroupOptions(options)
    }, this.props.children));
  }

}

_defineProperty(ValidationGroupInternal, "propTypes", {
  validationProps: _propTypes.default.shape({
    onValidate: _propTypes.default.func,
    i18n: _withDefaultI18n.i18nPropType,
    stopPropagation: _propTypes.default.bool,
    parent: _propTypes.default.instanceOf(_groupNode.GroupNode),
    schema: _propTypes.default.shape({
      type: _propTypes.default.string
    }),
    validator: _propTypes.default.func,
    convertor: _propTypes.default.shape({
      fromJSON: _propTypes.default.func,
      toJSON: _propTypes.default.func
    }),
    data: _propTypes.default.object // eslint-disable-line

  }),
  children: _propTypes.default.node.isRequired
});

_defineProperty(ValidationGroupInternal, "defaultProps", {
  validationProps: {
    onValidate: _underscore.default.noop,
    i18n: undefined,
    schema: undefined,
    parent: undefined,
    stopPropagation: false,
    validator: undefined,
    convertor: undefined
  }
});

const ValidationGroup = (0, _withDefaultI18n.withDefaultI18n)(ValidationGroupInternal);
exports.ValidationGroup = ValidationGroup;

/***/ }),

/***/ 1204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withError = withError;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _errorMessages = __webpack_require__(1205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function withError(Component, ErrorComponent = _errorMessages.ErrorMessages) {
  var _class, _temp;

  return _temp = _class = class ErrorWrapper extends _react.default.Component {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "state", {
        messages: [],
        isDirty: false
      });

      _defineProperty(this, "onValidate", item => {
        if (_underscore.default.isFunction(this.props.validationProps.onValidate)) {
          this.props.validationProps.onValidate(item);
        }

        this.setState({
          messages: item.messages,
          isDirty: item.isDirty
        });
      });

      _defineProperty(this, "getErrorMessages", (showSingleError, errorFilter) => {
        const errorMessages = _underscore.default.isFunction(errorFilter) ? [..._underscore.default.filter(this.state.messages, errorFilter), ..._underscore.default.result(this.props.validationProps, 'passiveMessages', [])] : [...this.state.messages, ..._underscore.default.result(this.props.validationProps, 'passiveMessages', [])];
        return showSingleError ? errorMessages.slice(0, 1) : errorMessages;
      });
    }

    render() {
      const _this$props$validatio = this.props.validationProps,
            passiveMessages = _this$props$validatio.passiveMessages,
            showErrorOnPassiveMessages = _this$props$validatio.showErrorOnPassiveMessages,
            alwaysShowError = _this$props$validatio.alwaysShowError,
            showSingleError = _this$props$validatio.showSingleError,
            errorFilter = _this$props$validatio.errorFilter;
      const renderError = alwaysShowError || this.state.isDirty || !_underscore.default.isEmpty(passiveMessages) ? _react.default.createElement(ErrorComponent, {
        messages: this.getErrorMessages(showSingleError, errorFilter)
      }) : null;

      const validationProps = _underscore.default.defaults({
        onValidate: this.onValidate,
        forceErrorClassName: showErrorOnPassiveMessages ? !_underscore.default.isEmpty(passiveMessages) : undefined
      }, this.props.validationProps);

      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Component, _extends({}, this.props, {
        validationProps: validationProps
      })), renderError);
    }

  }, _defineProperty(_class, "propTypes", {
    validationProps: _propTypes.default.shape({
      onValidate: _propTypes.default.func,
      alwaysShowError: _propTypes.default.bool,
      showErrorOnPassiveMessages: _propTypes.default.bool,
      passiveMessages: _propTypes.default.arrayOf(_propTypes.default.string),
      showSingleError: _propTypes.default.bool,
      errorFilter: _propTypes.default.func
    })
  }), _defineProperty(_class, "defaultProps", {
    validationProps: {
      onValidate: _underscore.default.noop,
      alwaysShowError: false,
      showErrorOnPassiveMessages: false,
      passiveMessages: [],
      showSingleError: false,
      errorFilter: undefined
    }
  }), _temp;
}

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessagesUnwrapped = ErrorMessagesUnwrapped;
exports.ErrorMessages = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function ErrorMessagesUnwrapped({
  messages,
  className
}) {
  if (_underscore.default.isEmpty(messages) || !_underscore.default.isArray(messages)) {
    return null;
  }

  return _react.default.createElement("div", {
    role: "alert"
  }, _underscore.default.map(messages, (message, key) => _underscore.default.has(message, 'DangerousHtmlMessage') ? _react.default.createElement("div", {
    key: key,
    className: className // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: message.DangerousHtmlMessage
    }
  }) : _react.default.createElement("div", {
    key: key,
    className: className
  }, message)));
}

ErrorMessagesUnwrapped.displayName = 'ErrorMessages';
ErrorMessagesUnwrapped.propTypes = {
  className: _propTypes.default.string,
  messages: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    DangerousHtmlMessage: _propTypes.default.string
  })]))
};
ErrorMessagesUnwrapped.defaultProps = {
  className: 'error',
  messages: []
};
const ErrorMessages = (0, _react.memo)(ErrorMessagesUnwrapped);
exports.ErrorMessages = ErrorMessages;

/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckedAdapter = void 0;

var _adapterFactory = __webpack_require__(1192);

const CheckedAdapter = (0, _adapterFactory.AdapterFactory)({
  valueToInject: 'checked'
});
exports.CheckedAdapter = CheckedAdapter;

/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckedItemAdapter = void 0;

var _adapterFactory = __webpack_require__(1192);

const CheckedItemAdapter = (0, _adapterFactory.AdapterFactory)({
  convertEventToValue: event => event.target.checked,
  defaultValue: false,
  valueToInject: 'checked'
});
exports.CheckedItemAdapter = CheckedItemAdapter;

/***/ }),

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericAdapter = void 0;

var _adapterFactory = __webpack_require__(1192);

const GenericAdapter = (0, _adapterFactory.AdapterFactory)({});
exports.GenericAdapter = GenericAdapter;

/***/ }),

/***/ 1209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCustomValidation = withCustomValidation;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _dummyNode = __webpack_require__(1210);

var _withValidation = __webpack_require__(1190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function withCustomValidation(Component, methodName = 'updateValidation') {
  class ValidationWrapper extends _react.default.PureComponent {
    constructor(props) {
      super(props);

      _defineProperty(this, "updateValidation", (messages, data = null, shouldDirty = true) => {
        if (!_underscore.default.isEqual(messages, this.itemNode.accessor.messages) || data !== null && !_underscore.default.isEqual(data, this.itemNode.accessor.data)) {
          this.itemNode.trigger(messages, data, shouldDirty);

          if (_underscore.default.isFunction(this.props.validationProps.onValidate)) {
            this.props.validationProps.onValidate(this.itemNode.accessor);
          }
        }
      });

      _defineProperty(this, "injectedProps", {
        [methodName]: this.updateValidation
      });

      this.itemNode = new _dummyNode.DummyNode({
        parent: _underscore.default.result(props.validationProps, 'parent'),
        initialNodeValue: _underscore.default.result(props.validationProps, 'initialValue')
      });
    }

    componentDidMount() {
      this.itemNode.register();
    }

    componentWillUnmount() {
      this.itemNode.unregister();

      _underscore.default.result(this.props.validationProps, 'notifyDataChange');
    }

    render() {
      return _react.default.createElement(Component, _extends({}, this.injectedProps, this.props));
    }

  }

  _defineProperty(ValidationWrapper, "propTypes", {
    validationProps: _propTypes.default.shape({
      onValidate: _propTypes.default.func
    })
  });

  _defineProperty(ValidationWrapper, "defaultProps", {
    validationProps: {
      onValidate: _underscore.default.noop
    }
  });

  return (0, _withValidation.withValidationInternal)(ValidationWrapper);
}

/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DummyNode = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _baseNode = __webpack_require__(1196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const initialValue = {};

const validator = (changed, node) => node.messages;

const convertor = {
  fromJSON: (data, node) => {
    _underscore.default.extend(node, {
      value: data
    });
  },
  toJSON: node => node.value
};

class DummyNode extends _baseNode.BaseNode {
  constructor({
    parent,
    initialNodeValue = initialValue
  }) {
    super({
      parent,
      validator,
      convertor
    });
    this.value = initialNodeValue;
  }

  trigger(messages, value = this.value, shouldDirty = true) {
    this.messages = messages;

    if (value !== this.value) {
      this.value = value;

      if (shouldDirty) {
        this.setDirty();
      }
    }

    this.parent.notifyChildChange(this);
  }

}

exports.DummyNode = DummyNode;

/***/ }),

/***/ 1211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withServerError = exports.useServerError = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _serverErrorContext = __webpack_require__(1212);

var _serverErrorUtils = __webpack_require__(1214);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const useServerError = props => {
  const serverErrorProps = props.serverErrorProps,
        _props$passiveMessage = props.passiveMessages,
        passiveMessages = _props$passiveMessage === void 0 ? [] : _props$passiveMessage;

  const _ref = serverErrorProps || {},
        clientId = _ref.clientId,
        fieldSelector = _ref.fieldSelector,
        propEntity = _ref.entity,
        code = _ref.code;

  const _useContext = (0, _react.useContext)(_serverErrorContext.ServerErrorContext),
        errors = _useContext.errors;

  const contextEntity = (0, _react.useContext)(_serverErrorContext.ServerErrorEntityContext);
  const entity = propEntity || contextEntity || '';
  return (0, _react.useMemo)(() => {
    let matchedErrors = [];

    if (errors && errors[entity]) {
      matchedErrors = _underscore.default.flatten(_underscore.default.values(_underscore.default.pick(errors[entity], (v, k) => (0, _serverErrorUtils.matchesField)(k, fieldSelector))));
    }

    if (code) {
      matchedErrors = _underscore.default.filter(matchedErrors, e => (0, _serverErrorUtils.matchesField)(e.errorCode, code));
    }

    if (clientId) {
      matchedErrors = _underscore.default.filter(matchedErrors, e => (0, _serverErrorUtils.matchesField)(e.clientId, clientId));
    }

    const errorMessages = _underscore.default.map(matchedErrors, e => e.message);

    return [...passiveMessages, ...errorMessages];
  }, [clientId, entity, errors, fieldSelector, passiveMessages, code]);
};

exports.useServerError = useServerError;

const withServerError = Component => {
  const HOC = _react.default.memo(props => {
    const serverErrorProps = props.serverErrorProps,
          validationProps = props.validationProps;

    const _ref2 = serverErrorProps || {},
          fieldSelector = _ref2.fieldSelector,
          propEntity = _ref2.entity;

    const _ref3 = validationProps || {},
          _ref3$passiveMessages = _ref3.passiveMessages,
          passiveMessages = _ref3$passiveMessages === void 0 ? [] : _ref3$passiveMessages,
          onValidate = _ref3.onValidate;

    const _useContext2 = (0, _react.useContext)(_serverErrorContext.ServerErrorContext),
          removeErrors = _useContext2.removeErrors;

    const contextEntity = (0, _react.useContext)(_serverErrorContext.ServerErrorEntityContext);
    const entity = propEntity || contextEntity || '';
    const messages = useServerError({
      serverErrorProps,
      passiveMessages
    });
    const validate = (0, _react.useCallback)(item => {
      if (_underscore.default.isFunction(onValidate)) {
        onValidate(item);
      }

      removeErrors({
        entity,
        fieldSelector
      });
    }, [entity, fieldSelector, onValidate, removeErrors]);

    const componentProps = _objectSpread({}, _underscore.default.omit(props, 'serverErrorProps'), {
      validationProps: _objectSpread({}, validationProps, {
        passiveMessages: messages,
        onValidate: validate
      })
    });

    return _react.default.createElement(Component, componentProps);
  });

  HOC.propTypes = {
    serverErrorProps: _propTypes.default.shape({
      fieldSelector: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
      entity: _propTypes.default.string,
      code: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
    }),
    validationProps: _propTypes.default.shape({
      onValidate: _propTypes.default.func,
      passiveMessages: _propTypes.default.arrayOf(_propTypes.default.string)
    })
  };
  HOC.defaultProps = {
    validationProps: {},
    serverErrorProps: {
      fieldSelector: ''
    }
  };
  return HOC;
};

exports.withServerError = withServerError;

/***/ }),

/***/ 1212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerErrorGroup = exports.ServerErrorContext = exports.ServerErrorEntity = exports.ServerErrorEntityContext = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _errorMapper = __webpack_require__(1213);

var _i18nContext = __webpack_require__(16);

var _serverErrorUtils = __webpack_require__(1214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
  Server error entity context
*/
const ServerErrorEntityContext = _react.default.createContext();

exports.ServerErrorEntityContext = ServerErrorEntityContext;

const ServerErrorEntity = _react.default.memo(props => {
  const entity = props.entity,
        children = props.children;
  return _react.default.createElement(ServerErrorEntityContext.Provider, {
    value: entity
  }, children);
});

exports.ServerErrorEntity = ServerErrorEntity;
ServerErrorEntity.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  entity: _propTypes.default.string.isRequired
};
/*
  Server error context
*/

const ServerErrorContext = _react.default.createContext({});

exports.ServerErrorContext = ServerErrorContext;

const ServerErrorGroup = _react.default.memo(props => {
  const children = props.children,
        rawErrorToMessageMapper = props.rawErrorToMessageMapper,
        instrumentation = props.instrumentation;

  const _useState = (0, _react.useState)({}),
        _useState2 = _slicedToArray(_useState, 2),
        errors = _useState2[0],
        setErrors = _useState2[1];

  const i18n = (0, _react.useContext)(_i18nContext.I18nContext);
  const mapErrors = rawErrorToMessageMapper || (0, _errorMapper.getErrorFromRawFn)(i18n, instrumentation); // server error code is not unique for now, so we temporarily depend on server error messages
  // when MT fixed this error code issue, we should not use server error message any more

  const setServerError = (0, _react.useCallback)(({
    error,
    entity = '',
    field,
    useServerErrorMessage = false,
    ignore
  }) => {
    setErrors(e => _objectSpread({}, e, {
      [entity]: (0, _serverErrorUtils.ignoreErrorCode)(mapErrors(error, entity, field, useServerErrorMessage), ignore)
    }));
  }, [mapErrors]);
  const removeErrors = (0, _react.useCallback)(({
    entity = '',
    fieldSelector = () => true,
    clientId = () => true,
    code = () => true
  }) => {
    setErrors(e => (0, _serverErrorUtils.removeErrorsFromContext)(e, entity, fieldSelector, clientId, code));
  }, []);
  return _react.default.createElement(ServerErrorContext.Provider, {
    value: {
      errors,
      setServerError,
      removeErrors
    }
  }, children);
});

exports.ServerErrorGroup = ServerErrorGroup;
ServerErrorGroup.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  rawErrorToMessageMapper: _propTypes.default.func,
  instrumentation: _propTypes.default.shape({
    logError: _propTypes.default.func
  })
};
ServerErrorGroup.defaultProps = {
  rawErrorToMessageMapper: null,
  instrumentation: null
};

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1213__;

/***/ }),

/***/ 1214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ignoreErrorCode = exports.removeErrorsFromContext = exports.excludeFields = exports.matchesField = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const matchesField = (field, fieldSelector) => {
  if (_underscore.default.isArray(fieldSelector)) {
    return fieldSelector.includes(field);
  } else if (_underscore.default.isString(fieldSelector)) {
    // Handle field name match as well as comma separated set of field names
    const values = fieldSelector.split(',');
    return _underscore.default.any(values, v => v.trim() === field);
  } else if (_underscore.default.isObject(fieldSelector) && _underscore.default.isFunction(fieldSelector.test)) {
    // Handle regex match
    return fieldSelector.test(field);
  } else if (_underscore.default.isFunction(fieldSelector)) {
    return fieldSelector(field);
  }

  return false;
};

exports.matchesField = matchesField;

const excludeFields = values => new RegExp(`^(?!(${values.replace(/,/g, '|')})$).*$`);

exports.excludeFields = excludeFields;

const removeErrorsFromContext = (context, entity = '', fieldSelector = () => true, clientId = () => true, code = () => true) => _objectSpread({}, context, {
  [entity]: _underscore.default.mapObject(context[entity] || {}, (fieldErrors, fieldName) => matchesField(fieldName, fieldSelector) ? _underscore.default.filter(fieldErrors, v => !(matchesField(v.clientId, clientId) && matchesField(v.errorCode, code))) : fieldErrors)
});

exports.removeErrorsFromContext = removeErrorsFromContext;

const ignoreErrorCode = (mappedErrors, ignore) => {
  if (ignore) {
    return _underscore.default.mapObject(mappedErrors || {}, fieldErrors => _underscore.default.filter(fieldErrors, v => !matchesField(v.errorCode, ignore)));
  }

  return mappedErrors;
};

exports.ignoreErrorCode = ignoreErrorCode;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__590__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ })

/******/ })});;
